// extracted by mini-css-extract-plugin
export default {"noborder":"TimeEdit_noborder__EFwpH"};